export default __webpack_public_path__ + "static/store-apple.fr-1801b9b22cbbd37770ffafdfce38a464.png";